import React from 'react'

import { styled } from '@linaria/react'
import { FormattedMessage } from 'react-intl'
import { useDispatch } from 'react-redux'

import { metaphorSlideLimitNoVip } from 'common-constants/metaphor'
import { ClipPathOuter } from 'components/block/Profile/ProfileMain/profileMain.styled'
import { MainLayout } from 'components/designSystem/layout/MainLayout/MainLayout'
import promoVipLike from 'components/designSystem/svg/promo-vip-like.svg'
import { storeFrontVipPath } from 'components/storefront/StoreFront.paths'
import { mergeAllUrls } from 'functions/mergeAllUrls'
import { push } from 'functions/router'
import { useLayoutContext } from 'hooks/useLayoutContext'

export const PromoVipLike = () => {
  const dispatch = useDispatch()
  const { baseUrl } = useLayoutContext()

  const handlePrimaryButtonClick = () => {
    dispatch(
      push(mergeAllUrls(baseUrl, storeFrontVipPath, metaphorSlideLimitNoVip))
    )
  }

  return (
    <Parent>
      <MainLayout
        title={
          <FormattedMessage
            id="app.continue.vip.title"
            defaultMessage="Продолжи, как VIP"
          />
        }
        description={
          <FormattedMessage
            id="app.continue.vip.description"
            defaultMessage="Активируй VIP и получи дополнительные 500 голосов в день"
          />
        }
        icon={<img src={promoVipLike} width={200} height={200} />}
        backButtonVisible={false}
        onPrimaryButtonClick={handlePrimaryButtonClick}
        primaryButtonText={
          <FormattedMessage
            id="form.button.activate"
            defaultMessage="Активировать"
          />
        }
        secondaryButtonColor="accent"
        increasePaddingBottom={true}
        noBorder={true}
        wrapperStyle={{
          background: 'var(--pearl-opacity-default)',
        }}
      />
    </Parent>
  )
}

const Parent = styled(ClipPathOuter)`
  width: 100%;
  background-color: var(--background-page);
`
